let version032 = [
  {
    title: '🐞 修复 色彩和字体中图片引入错误的问题使用当前文件相对路径 ',
    href: 'https://github.com/PIdoll/DBox/pull/534',
    reqId: '#534'
  }
];

let version031 = [
  {
    title: '🐞 修复 色彩和字体中图片引入错误的问题 ',
    href: 'https://github.com/PIdoll/DBox/pull/530',
    reqId: '#530'
  }
];

let version030 = [
    {
        title: '🐞 修复 组件文档色彩和字体模块报错 ',
        href: 'https://github.com/PIdoll/DBox/pull/526 ',
        reqId: '#526'
    },
    {
        title: '🐞 修复 组件资源中sketch错写成skeych',
        href: 'https://github.com/PIdoll/DBox/pull/526 ',
        reqId: '#526'
    },
    {
        title: '🐞 修复 Button幽灵按钮增加icon后，图标颜色和字体颜色不一致的问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/524',
        reqId: '#524'
    },
    {
        title: '🐞 修复 Cascader中 loadData 加 载的图标错误问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/527',
        reqId: '#527'
    },
    {
        title: '🐞 修复 Input Select DataPicker TimePicker 中清除图标尺寸不一致的问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/523',
        reqId: '#523'
    },
    {
        title: '🐞 修复table在无key的情况下选中所在行无变化的问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/525',
        reqId: '#525'
    },
    {
        title: '💄 优化 Table内嵌表格子表格样式,增加灰色背景用于区别子父层级 ',
        href: 'https://github.com/PIdoll/DBox/pull/525',
        reqId: '#525'
    },
    {
        title: '💄 优化 贡献成员头像尺寸更改为80*80 ',
        href: 'https://github.com/PIdoll/DBox/pull/526',
        reqId: '#526'
    },
    {
        title: '🛠 新增icon 类型为assistant、wechat、pause_circle、position ',
        href: 'https://github.com/PIdoll/DBox/pull/521',
        reqId: '#521'
    },
];

let version029 = [
    {
        title: '📢 更新 组件官网首页 ',
        href: 'https://github.com/PIdoll/DBox/pull/506',
        reqId: '#506'
    },
    {
        title: '🐞 修复 Table组件排序图标过小 ',
        href: 'https://github.com/PIdoll/DBox/pull/497',
        reqId: '#506'
    },
    {
        title: '🐞 修复 Tag组件cursor: pointer场景 ',
        href: 'https://github.com/PIdoll/DBox/pull/507',
        reqId: '#507'
    },
    {
        title: '🐞 修复 Affix组件无法固定在容器顶部 ',
        href: 'https://github.com/PIdoll/DBox/pull/517',
        reqId: '#517'
    },
    {
        title: '🐞 修复 Dropdown组件disabled属性',
        href: 'https://github.com/PIdoll/DBox/pull/510',
        reqId: '#510'
    },
    {
        title: '🐞 修复 Badge组件设置和显示数字不一致 ',
        href: 'https://github.com/PIdoll/DBox/pull/498',
        reqId: '#498'
    },
    {
        title: '🐞 修复 Steps组件竖直场景下步骤图标距离 ',
        href: 'https://github.com/PIdoll/DBox/pull/511',
        reqId: '#511'
    },
    {
        title: '🐞 修复 Calendar日历组件切换日期箭头颜色 ',
        href: 'https://github.com/PIdoll/DBox/pull/500',
        reqId: '#500'
    },
    {
        title: '💄 优化 Modal组件 confirm场景下组件样式统一 ',
        href: 'https://github.com/PIdoll/DBox/pull/496',
        reqId: '#496'
    },
    {
        title: '🛠 新增 Radio组件只读API readOnly hidden ',
        href: 'https://github.com/PIdoll/DBox/pull/516',
        reqId: '#516'
    },
    {
        title: '🛠 新增 Checkbox组件只读API readOnly hidden ',
        href: 'https://github.com/PIdoll/DBox/pull/505',
        reqId: '#505'
    }
];

let version028 = [
    {
        title: '🐞 移除 Form hideRequiredMark ',
        href: 'https://github.com/PIdoll/DBox/pull/477',
        reqId: '#477'
    },
    {
        title: '🐞 修复 Calendar禁用文字样式看不清。',
        href: 'https://github.com/PIdoll/DBox/pull/476',
        reqId: '#476'
    },
    {
        title: '🐞 移除 Modal头部，底部多余的margin ',
        href: 'https://github.com/PIdoll/DBox/pull/470',
        reqId: '#470'
    },
    {
        title: '🐞 修复 table带选择框选中所在行背景无变化 ',
        href: 'https://github.com/PIdoll/DBox/pull/484',
        reqId: '#484'
    },
    {
        title: '🐞 修复 API allowEmpty 无清除效果的问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/476',
        reqId: '#510'
    },
    {
        title: '🐞 修复 Badge必须在最顶层添加state，类名才能生效 ',
        href: 'https://github.com/PIdoll/DBox/pull/474',
        reqId: '#474'
    },
    {
        title: '🐞 修复 Select disabled 为true 时字体颜色和背景颜色一致 ',
        href: 'https://github.com/PIdoll/DBox/pull/490',
        reqId: '#490'
    },
    {
        title: '🐞 修复 设置format设为 HH:mm 时，时间面板秒的一列会空白一列 ',
        href: 'https://github.com/PIdoll/DBox/pull/487',
        reqId: '#487'
    },
    {
        title: '🐞 修复 DatePicker组件中format属性为数组时，PropType数组校验报错 ',
        href: 'https://github.com/PIdoll/DBox/pull/478',
        reqId: '#478'
    },
    {
        title: '🐞 修复 menu在禁用条件下hover状态不正确、顶部导航高度写死问题 ',
        href: 'https://github.com/PIdoll/DBox/pull/482',
        reqId: '#482'
    },
    {
        title: '🛠 新增Table columns的显隐API hidden',
        href: 'https://github.com/PIdoll/DBox/pull/482',
        reqId: '#482'
    }
];

export {
    version032,
    version031,
    version030,
    version029,
    version028
};
